import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  id: string;
};

const [useDeleteProductType, deleteProductType] = createAsyncAction(
  "productTypes/delete",
  async ({ spaceId, id }: Args) => {
    return await API.call<Record<string, never>>({
      endpoint: `spaces/${spaceId}/product-types/${id}`,
      method: "DELETE",
    });
  }
);

export default useDeleteProductType;
export { deleteProductType };
